module.exports = "/assets/data/8a65c9e505e6b838d99081491814f58c-CV37.data.json";